import { devnetConfig } from 'consts/devnetConfig';

export default {
  name: 'Wowmax',
  timestamp: '',
  version: {
    major: 1,
    minor: 0,
    patch: 0,
  },
  tags: {},
  logoURI: '',
  keywords: ['wowmax'],
  tokens: [
    {
      address: '0x0000000000000000000000000000000000000000',
      symbol: 'ETH',
      name: 'Ether',
      decimals: 18,
      chainId: 31337,
      logoURI: '',
      tags: ['native'],
      info: {
        coinGeckoId: 'ethereum',
        coinMarketCapId: 1027,
        hasGeckoTerminal: null,
      },
    },
    {
      address: devnetConfig.tokens.WETH,
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
      chainId: 31337,
      logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png',
      tags: ['wrappedNative'],
      info: {
        coinGeckoId: '',
        coinMarketCapId: 0,
      },
    },
    {
      address: devnetConfig.tokens.STONE,
      symbol: 'STONE',
      name: 'StakeStone Ether',
      decimals: 18,
      chainId: 31337,
      logoURI: 'https://assets.coingecko.com/coins/images/33103/large/200_200.png?1702602672',
      tags: [],
      info: {
        coinGeckoId: '',
        coinMarketCapId: 0,
      },
    },
    {
      address: devnetConfig.tokens.USDC,
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 6,
      chainId: 31337,
      logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
      tags: [],
      info: {
        coinGeckoId: '',
        coinMarketCapId: 0,
      },
    },
    {
      address: devnetConfig.tokens.USDT,
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 6,
      chainId: 31337,
      logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
      tags: [],
      info: {
        coinGeckoId: '',
        coinMarketCapId: 0,
      },
    },
    {
      address: devnetConfig.tokens.MANTA,
      symbol: 'MANTA',
      name: 'Manta',
      decimals: 18,
      chainId: 31337,
      logoURI: 'https://docs.manta.network/img/manta2.png',
      tags: [],
      info: {
        coinGeckoId: '',
        coinMarketCapId: 0,
      },
    },
  ],
};
